import { render } from "./VNotification.vue?vue&type=template&id=cac9a43a"
import script from "./VNotification.vue?vue&type=script&lang=js"
export * from "./VNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__